import { types, flow, getParent, getRoot } from 'mobx-state-tree';
import { getOr } from 'lodash/fp';

const URL = 'business-policy/v1/return-policies';

const EbayReturnPolicies = types
  .model('EbayReturnPolicies', {
    days: types.optional(types.string, ''),
    domesticDays: types.optional(types.union(types.number, types.string), ''),
    internationalDays: types.optional(types.union(types.number, types.string), ''),
    name: types.optional(types.string, ''),
    isButtonDisabled: types.optional(types.boolean, true),
  })
  .views(self => ({
    get policyCode() {
      return getParent(self).policyNormalizedOptions.returns.code;
    },
    get requestData() {
      const data = {
        domesticDays: parseInt(self.domesticDays, 10),
        internationalDays: parseInt(self.internationalDays, 10),
        name: self.name,
        destinationMarketplaceId: getRoot(self).uiStore.settingsStore.policies.selectedDestId,
      };
      const headers = {
        'Seller-Account-Id': getParent(self).sellerAccountCode,
      };
      return { headers, data };
    },
  }))
  .views(self => ({
    get returnPolicyList() {
      return getParent(self).returnPolicyList;
    },
  }))
  .actions(self => ({
    setPolicyName(e = {}) {
      const name = getOr('', 'target.value', e);
      self.name = name;
      self.validateFields();
    },
    setDomesticDays(value) {
      self.domesticDays = value;
      self.validateFields();
    },
    setInternationalDays(value) {
      self.internationalDays = value;
      self.validateFields();
    },
    createNewPolicy: flow(function* createNewPolicy() {
      try {
        const { headers, data } = self.requestData;
        self.isButtonDisabled = true;
        yield getParent(self, 3).transport5007.post(URL, data, {}, headers);
        yield getParent(self, 3).fetchPolicyFormOptions();
      } catch (err) {
        console.log(err);
        yield err;
      }
    }),
    updatePolicy: flow(function* updatePolicy() {
      try {
        const { headers, data } = self.requestData;
        const finalData = { ...data, businessPolicyId: self.policyCode };
        self.isButtonDisabled = true;
        yield getParent(self, 3).transport5007.update(URL, finalData, {}, headers);
        getParent(self, 3).fetchPolicyFormOptions();
      } catch (err) {
        console.log(err);
      }
    }),
    validateFields() {
      if (self.name !== '' && self.internationalDays !== '' && self.domesticDays !== '') {
        self.isButtonDisabled = false;
      }
    },
    cancelFormSelection() {
      self.name = '';
      self.domesticDays = '';
      self.internationalDays = '';
      self.isButtonDisabled = true;
    },
  }));

export default EbayReturnPolicies;
